import {Route, Routes} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './custom.css';
import {AppContext, useApplicationConfiguration} from "./shared/AppContext";
import React from "react";
import Layout from "./components/Layout";
import {mBankCorporate} from "@mbank-design/design-system/themes";
import {GlobalStyles} from "@mbank-design/design-system/styles";
import {DesignSystemOverlayProvider, DesignSystemThemeProvider} from "@mbank-design/design-system/providers";

export default function App () {
    const configuration = useApplicationConfiguration();
    
    return (
        <DesignSystemThemeProvider theme={mBankCorporate}>
            <DesignSystemOverlayProvider>
                <GlobalStyles />
                <Layout>
                    <AppContext.Provider value={configuration}>
                        <Routes>
                            {AppRoutes.map((route, index ) => {
                                const {id, element, ...rest} = route;
                                return <Route key={id} {...rest} element={element}/>;
                            })}
                        </Routes>
                    </AppContext.Provider>
                </Layout>
            </DesignSystemOverlayProvider>
        </DesignSystemThemeProvider>
    );
}
